export default {"src":"/_next/static/media/lychee.605f848d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};